<template>
    <div>
        <div class="vx-row">
            <div class="vx-col pt-2">
            <span>Recherche par keyword : </span>
            </div>
            <div class="vx-col">
            <vs-input class="inputx" placeholder="Keyword" v-model="keywordListingSearchInput"  />
            </div>
        </div>
        <vs-table ref="keywordListingPopupTable" stripe hoverFlat auto-resize pagination max-items="18" noDataText="" :data="data">
            <template slot="thead">
                <vs-th class="text-center" sort-key="keyword">Keyword</vs-th>
                <vs-th sort-key="position">Position</vs-th>
                <vs-th v-if="withvolumecpc" sort-key="volume">Volume</vs-th>
                <vs-th v-if="withvolumecpc" sort-key="cpc">CPC</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="index" v-for="(row, index) of data">
                    <vs-td>
                        <strong>{{ row.keyword }}</strong>
                    </vs-td>
                    <vs-td class="txt_align_right">
                        {{ row.position }}
                    </vs-td>
                    <vs-td v-if="withvolumecpc" class="txt_align_right">
                        <span>{{ formatThousandNumb(row.volume) }}</span>
                    </vs-td>
                    <vs-td v-if="withvolumecpc" class="txt_align_right">
                        <span>{{ row.cpc + '€' }}</span>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</template>
<script>
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "KeywordListTable",
	props: {
		data: {
			type: Array,
			default: []
		},
		withvolumecpc: {
			type: Boolean,
			default: false
		}
	},
	mixins: [utilsMixin],
	data() {
		return {
			keywordListingSearchInput: "",
		};
	},
	watch: {
		keywordListingSearchInput: function(data){
			this.$refs.keywordListingPopupTable.searchx = data;
		},
	}
};
</script>
<style lang="scss" scoped>
.txt_align_right {
  text-align: right !important;
}
</style>